import { toast } from 'sonner'
import _ from 'lodash'

export const handleFormError = ({
  error,
  variables,
  setError,
  showToast = false,
  clientServerFieldMapping: _clientServerFieldMapping = null,
}) => {
  if (!error?.hasFieldError) return
  const serverFieldErrors = error?.response?.data?.errors ?? []

  let fieldFound = false
  const clientServerFieldMapping =
    variables?.clientServerFieldMapping ?? _clientServerFieldMapping ?? {}

  //Swap key values so we can easily look for server fieldName
  const serverClientFieldMapping = Object.fromEntries(
    Object.entries(clientServerFieldMapping).map(([key, value]) => [
      value,
      key,
    ]),
  )

  Object.entries(serverFieldErrors).map(([serverFieldName, value]) => {
    const serverFieldNameCamelCase = _.camelCase(serverFieldName)

    const availableClientFieldNameFromTheRequest =
      serverFieldName in serverClientFieldMapping
        ? serverClientFieldMapping[serverFieldName]
        : serverFieldNameCamelCase in variables
          ? serverFieldNameCamelCase
          : null

    if (availableClientFieldNameFromTheRequest) {
      const error = (value ?? [])[0]
      if (error) {
        if (setError)
          setError(availableClientFieldNameFromTheRequest, { message: error })
        fieldFound = true
        if (showToast || !setError) {
          toast.error(error)
        }
      }
    }
  })

  if (!fieldFound) {
    toast.error(error?.response?.data?.message ?? 'An error occurred.')
  }
}
